import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import FlowentiLogo from "../image/Logo.svg";

export interface Step {
  number: number;
  title: string;
  description?: string;
}

interface LandingSidebarProps {
  title: string;
  steps: Step[];
}

const LandingSidebar: React.FC<LandingSidebarProps> = ({ title, steps }) => {
  const year = new Date().getFullYear();
  return (
    <Box
      data-testid="auth-sidebar"
      sx={{
        flex: 1,
        background: "linear-gradient(135deg, #1a2332 0%, #0f1419 100%)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        p: { xs: 3, md: 6 },
        // ml: { xs: 2, md: 46 }
      }}
    >
      {/* Logo */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, ml: { xs: 2, md: 14 } }}>
        <img
          src={FlowentiLogo}
          alt="Flowenti"
          style={{ height: "32px", width: "auto" }}
        />
        <Typography variant="h4" sx={{
          color: "white", fontWeight: 700,
        }} >
          Flowenti
        </Typography>
      </Box>

      {/* Content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          pl: { xs: 0, md: 8 },
          ml: { xs: 2, md: 8 }
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: "white",
            fontWeight: 700,
            mb: 2,
            fontSize: "2rem",
          }}
        >
          {title}
        </Typography>
        <Stack spacing={3}>
          {steps.map((step, index) => (
            <Box
              key={step.number}
              sx={{
                display: "flex",
                gap: 2,
                position: "relative",
                py: 6,
              }}
            >
              {/* Connecting Line */}
              {index < steps.length - 1 && (
                <Box
                  sx={{
                    position: "absolute",
                    left: "19px",
                    top: "40px",
                    width: "2px",
                    height: "calc(100% + 12px)",
                    background: "rgba(255, 255, 255, 0.1)",
                  }}
                />
              )}

              {/* Step Number Circle */}
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  background:
                    "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontWeight: 700,
                  fontSize: "1.1rem",
                  flexShrink: 0,
                  zIndex: 1,
                  boxShadow: "0 4px 12px rgba(37, 99, 235, 0.4)",
                }}
              >
                {step.number}
              </Box>

              {/* Step Content */}
              <Box sx={{ flex: 1 }}>
                <Typography
                  variant="h6"
                  sx={{
                    color: "white",
                    fontWeight: 600,
                    mb: 0.5,
                    fontSize: "1.1rem",
                  }}
                >
                  {step.title}
                </Typography>
                {step.description && (
                  <Typography
                    variant="body2"
                    sx={{
                      color: "rgba(255, 255, 255, 0.6)",
                      lineHeight: 1.5,
                    }}
                  >
                    {step.description}
                  </Typography>
                )}
              </Box>
            </Box>
          ))}
        </Stack>
      </Box>

      {/* Footer */}
      <Typography
        variant="body2"
        sx={{
          color: "rgba(255, 255, 255, 0.4)",
          fontSize: "0.875rem",
          ml: { xs: 2, md: 18 }
        }}
      >
        © {year} Flowenti. All rights reserved.
      </Typography>
    </Box>
  );
};

export default LandingSidebar;
